/**
 * ColorGridDisplay.js
 * Displays the original colored 6×6 grid.
 */

export default function ColorGridDisplay({ grid }) {
    return (
        <div className="grid grid-cols-6 gap-2 sm:gap-3 justify-center mt-6">
            {grid.map((color, i) => (
                <div
                    key={i}
                    className={`w-10 h-10 sm:w-14 sm:h-14 border border-zinc-700 rounded-md ${
                        color ? `bg-${color.toLowerCase()}` : "bg-zinc-800"
                    }`}
                ></div>
            ))}
        </div>
    );
}